import d3 from '~/core/scripts/chart-components/d3';

export const parseData = rawData => {
  return [...d3.group(rawData, d => d.Jahr).entries()].map(d => {
    const res = {};
    const [year, items] = d;
    const filteredItems = items.filter(item => item.Segment !== 'INSGESAMT');
    const sum = filteredItems.reduce((res, item) => {
      res += item.value;
      return res;
    }, 0);

    res.year = year;

    filteredItems.forEach(item => {
      res[item.Segment] = item.value;
      res[`${item.Segment}_rel`] = (item.value / sum) * 100;
    });

    return res;
  });
};

const sortBy = (a, b) => {
  return a[1] - a[0] - (b[1] - b[0]);
};

export const sortSeries = series => {
  for (var i = 0; i < series[0].length; i++) {
    const values = series.map(layer => layer[i]).sort(sortBy);

    let y0 = 0;

    values.forEach((layer, li) => {
      const yd = layer[1] - layer[0];
      layer[0] = y0;
      layer[1] = y0 + yd;
      y0 += yd;
    });
  }
};

export const createChartData = (series, { xScale, yScale, color }) => {
  return series.map(currentSeries => {
    return {
      data: currentSeries.map((s, si) => ({
        key: `${currentSeries.key}__${si}`,
        x: xScale(s.data.year),
        y: yScale(s[1]),
        height: yScale(s[0]) - yScale(s[1]),
        width: xScale.bandwidth(),
        color: color(currentSeries.key)
      })),
      key: currentSeries.key
    };
  });
};

export const createAreaData = chartData => {
  return chartData.reduce((res, series) => {
    const area = {
      key: series.key,
      color: series.data[0].color,
      data: series.data.reduce((points, d) => {
        points.push({ x: d.x, y: d.y, y1: d.y + d.height, color: d.color });
        points.push({ x: d.x + d.width, y: d.y, y1: d.y + d.height, color: d.color });
        return points;
      }, [])
    };

    return res.concat(area);
  }, []);
};

// always render active area at the end
export const sortArea = activeArea => (a, b) => {
  return a.key === activeArea ? 1 : -1;
};

export const getRegistrations = (data, activeArea) => {
  return data.reduce((res, item) => {
    if (activeArea) {
      res.push(item[activeArea]);
    } else {
      const sum = Object.keys(item)
        .filter(d => d !== 'year')
        .reduce((regSum, key) => {
          regSum += item[key];
          return regSum;
        }, 0);

      res.push(sum);
    }

    return res;
  }, []);
};
